import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {Button, Checkbox, Dialog, DialogActions, DialogContent, Select, MenuItem, FormControl, InputLabel,
    DialogTitle, CircularProgress, Container, FormControlLabel, Grid, TextField,} from '@mui/material';

import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {CountryService, PartnerSiteService} from '../../../services';
import ValidationError from '../../shared/ValidationError';
import {NotificationContext} from "../../../components/NotificationContext";
import Prompt from "../../../customUtil/Prompt";
import { CurrentUserContext } from '../../../components/CurrentUserContext';


const PartnerSiteForm = () => {
    const methods = useForm();
    const [data, setData] = useState({});
    const [isReady, setIsReady] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const {showMessage, showError} = useContext(NotificationContext);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const {handleSubmit, control, errors, ref} = methods;
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
    const [open, setOpen] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const [isVisibleDialog, setVisibleDialog] = useState(false);
    const {rights} = useContext(CurrentUserContext);
    const [showProgress, setShowProgress] = useState(false);
    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );

      const handleClose = () => {
        setOpen(false);
        setOpenConfirmation(false);
        setOpenInfo(false);
    }
    const removePartnerSite = () => {
        setShowProgress(true);
        PartnerSiteService.delete(data.id).then((response) => {                
                showMessage('Successfully Deleted');
                history.push("/references/partner-site");   
                setShowProgress(false);                                
            }).catch((response) => {
            handleClose();
            setOpenInfo(true);
            setShowProgress(false);                                

        });
    }
      
      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

    useEffect(() => {
        CountryService.getAll()
            .then((response) => setCountryList(response.data));

        if (id !== "new") {
            PartnerSiteService.getById(id).then((response) => {
                setData(response.data);
                setIsReady(true);
            });
        } else {
            setData({country: {}});
            setIsReady(true);
        }
    }, [id]);


    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        if (data.id) {
            PartnerSiteService.update({...data, ...d})
                .then((response) => {
                    showMessage('Partner Site updated successfully.');
                }).catch((response) => {
                showError(response.message);
            });
        } else {
            PartnerSiteService.create({...data, ...d}).then((response) => {
                setData(response.data);
                showMessage('Partner site created.');
            });
        }
        setTimeout(() => {
            setIsReady(true);
            history.push('/references/partner-site')
        }, 100)     };

    if (!isReady) {
        return (<CircularProgress/>);
    }
    
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          console.log(event)
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }

    return (
        <Container>
            <header>
                <h1>Partner Sites (Ship-to)</h1>

            </header>
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <p>
                            The partner site is the delivery location for the shipment.
                        </p>
                    </Grid>

                    <Grid item xs={6}>
                        <Controller
                            name="partnerName"
                            control={control}
                            as={TextField}
                            fullWidth
                            label="Partner Name"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Partner Name is required.'}}
                            defaultValue={data.partnerName}
                            render={({onChange, value}) => <TextField
                                autoComplete="templateName"
                                value={value}
                            />}
                        />
                        <ValidationError error={errors.partnerName}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <Controller
                            name="oneNetCode"
                            control={control}
                            as={TextField}
                            fullWidth
                            label="One Net Code"
                            rules={{required: 'One Net code is required.'}}
                            color="primary"
                            variant="outlined"
                            defaultValue={data.oneNetCode}
                        />
                        <ValidationError error={errors.oneNetCode}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <InputLabel htmlFor="country" label="Country"/>
                            <Controller
                                id="country"
                                variant="outlined"
                                control={control}
                                name="country.id"
                                rules={{required: 'Country is required.'}}
                                label="Country"
                                defaultValue={data.country.id}
                                as={
                                    <Select ref={ref} label="Country" style={{minWidth: 300}} id="country">
                                        {
                                            countryList.map((option) => {
                                                return <MenuItem key={option.id} value={option.id}>
                                                    {option.countryName}
                                                </MenuItem>
                                            })
                                        }
                                    </Select>
                                }
                            />
                        </FormControl>
                        {errors.country && <ValidationError error={errors.country.id}/>}
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <Controller
                            name="address"
                            control={control}
                            as={TextField}
                            fullWidth
                            label="Address"
                            color="primary"
                            multiline
                            rules={{required: 'Address is required.'}}
                            rows={6}
                            variant="outlined"
                            defaultValue={data.address}
                            render={({onChange, value}) => <TextField
                                autoComplete="templateName"
                                value={value}
                            />}
                        />
                        <ValidationError error={errors.address}/>
                    </Grid>
                    <Grid item xs={9}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Grid>
                        {(rights.includes("ROLE_SI_ADMIN") && id !== 'new') &&                        
                        <Grid item xs={3}>
                            <Button variant="contained" color="danger" onClick={() => setOpenConfirmation(true)}>Remove Partner Site</Button>
                        </Grid>
                      }
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
            <Dialog open={openConfirmation} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>                      
                          Are you sure you want to delete this partner site?                                           
                    </DialogContent>
                    <DialogActions>
                        {showProgress &&  <CircularProgress style={{width: "12px", height: "10px"}}/>}                       
                    <Button onClick={removePartnerSite} color="primary" disabled={showProgress}>
                            yes
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openInfo} onClose={handleClose} aria-labelledby="form-dialog-title">                   
                    <DialogContent>                       
                          This partner site can not be deleted because it is already in use.                                             
                    </DialogContent>
                    <DialogActions>                    
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
        </Container>
    );
};

export default PartnerSiteForm;
